import { LinearGradient } from "expo-linear-gradient";
import { router } from "expo-router";
import React from "react";
import { StatusBar, Text, TouchableOpacity, View } from "react-native";
import { StyleSheet, scale } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import { Colors } from "@/constants/Colors";
import LottieConfetti from "@/components/LottieConfetti";
import Icons from "@/assets/icons";

const SubscriptionSuccessScreen = () => {
  const handleBackToHome = () => {
    router.dismissTo("/(tabs)/feeds");
  };

  return (
    <View style={styles.container}>
      <StatusBar barStyle="light-content" />
      <LinearGradient colors={["#26913B", "#243D3C"]} style={styles.gradient}>
        {/* Close Button */}
        <TouchableOpacity style={styles.closeButton} onPress={handleBackToHome}>
          <Text style={styles.closeButtonText}>✕</Text>
        </TouchableOpacity>

        <View style={styles.content}>
          {/* Main Content */}
          <View style={styles.mainContent}>
            {/* Sparrow Icon Badge */}
            <View style={styles.iconBadge}>
              <Icons.Logo
                width={scale(56)}
                height={scale(56)}
                color="#FFFFFF"
              />
            </View>

            {/* Title */}
            <Text style={styles.title}>You&apos;re in!</Text>

            {/* Description */}
            <Text style={styles.description}>
              Your subscription was successful. You&apos;ll now have access to
              unlimited claim filing.
            </Text>
          </View>

          {/* Back to Home Button */}
          <TouchableOpacity
            style={styles.backButton}
            onPress={handleBackToHome}
          >
            <Text style={styles.backButtonText}>Back to home</Text>
          </TouchableOpacity>
        </View>

        <LottieConfetti active={true} />
      </LinearGradient>
    </View>
  );
};

export default SubscriptionSuccessScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  gradient: {
    flex: 1,
  },
  content: {
    flex: 1,
    paddingHorizontal: 20,
    paddingBottom: 40,
    justifyContent: "space-between",
    paddingTop: 160,
  },
  mainContent: {
    alignItems: "center",
  },
  iconBadge: {
    width: 104,
    height: 104,
    borderRadius: 100,
    backgroundColor: "rgba(22, 29, 20, 0.5)",
    borderWidth: 2,
    borderColor: "rgba(255, 255, 255, 0.2)",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 25,
  },
  title: {
    fontSize: 30,
    fontFamily: FontFamilies.Inter.Medium,
    color: "white",
    textAlign: "center",
    marginBottom: 16,
    lineHeight: 37,
  },
  description: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "rgba(255, 255, 255, 0.7)",
    textAlign: "center",
    lineHeight: 23,
    marginBottom: 16,
  },
  backButton: {
    backgroundColor: Colors.primary,
    height: 58,
    borderRadius: 100,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 20,
  },
  backButtonText: {
    fontSize: 16,
    fontFamily: FontFamilies.Inter.Medium,
    color: "white",
    letterSpacing: -0.32,
  },
  closeButton: {
    position: "absolute",
    top: 60,
    right: 20,
    padding: 8,
    borderRadius: 15,
    zIndex: 10,
  },
  closeButtonText: {
    color: "white",
    fontSize: 20,
    fontWeight: "bold",
  },
});
